// extracted by mini-css-extract-plugin
export default {"combinedShieldRootV2":"combinedShieldRootV2___msps0","small":"small___ESAFJ","s":"s___oEpdD","m":"m___Nb3JP","l":"l___sFD0r","combinedShieldImgV2":"combinedShieldImgV2___Dh2Q7"};